export const AUTH_STALE_TIME = 5 * 60 * 1000;

export const authKeys = {
	all: ['auth'] as const,
	currentUser: () => [...authKeys.all, 'currentUser'] as const,
};
